/**
In this file we declare all our project's web routing based on the parent and physician  module
**/
import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import ApiService from "./services/ApiService";
import SuperAdminLogin from "./components/Home/SuperAdminLogin";
import HospitalAdminLogin from "./components/Home/HospitalAdminLogin";
import PhysicianLogin from "./components/Home/PhysicianLogin";
//import Landing from './components/Home/LandingPage';
import LandingTemplate from "./components/Landing/LandingTemplate";
import HeroBanner from "./components/Landing/HeroBanner";
import AboutNurture from "./components/Landing/AboutNurture";
import LandingParents from "./components/Landing/LandingParents";
import Clinics from "./components/Landing/Clinics";
import RequestDemo from "./components/Landing/RequestDemo";
import PrivacyPolicy from "./components/Landing/PrivacyPolicy";
import CreatePassword from "./components/Home/CreatePassword";
import Register from "./components/Home/Register";
import ForgotPassword from "./components/Home/ForgotPassword";
import Template from "./components/Layout/Template";
//import Dashboard from "./components/Physician/Dashboard/Dashboard";
import Dashboard from "./shared/components/Children";
import EditProfile from "./components/Physician/Profile/EditProfile";
import ViewProfile from "./components/Physician/Profile/ViewProfile";
//import Appointments from "./components/Physician/Appointments/Appointments";
import Appointments from "./shared/components/Appointments";
import Parents from "./components/Physician/Parents/Parents";
import Vaccination from "./components/Physician/Vaccination/Vaccination";
import ParentDashboard from "./components/Parent/Dashboard/Dashboard";
import Development from "./components/Physician/Development/Development";
import Measurement from "./components/Physician/Measurement/Measurement";
import MedicalIssues from "./components/Physician/MedicalIssues/MedicalIssues";
import Chat from "./components/Common/Chat";
import AccountSettings from "./components/Common/AccountSettings";
//import MemberProfile from "./components/Physician/MemberProfile/MemberProfile";
import MemberProfile from "./shared/components/MemberProfile";
import Notification from "./components/Physician/Notification/Notification";
import AdminDashboard from "./components/Superadmin/Dashboard/Dashboard";
import HospitalAdminDashboard from "./components/HospitalAdmin/Dashboard/Dashboard";
//import HospitalParent from "./components/HospitalAdmin/Parents/Parents";
import HospitalAddParent from "./components/HospitalAdmin/Parents/AddParent";
import HospitalEditParent from "./components/HospitalAdmin/Parents/EditParent";
import HospitalViewParent from "./components/HospitalAdmin/Parents/ViewParent";
import HospitalAddChildren from "./components/HospitalAdmin/Children/AddChildren";
import HospitalEditChildren from "./components/HospitalAdmin/Children/EditChildren";
//import HospitalChildren from "./components/HospitalAdmin/Children/Children";
//import Parent from "./components/Superadmin/Parents/Parent";
import Parent from "./shared/components/Parent";
import AddParent from "./components/Superadmin/Parents/AddParent";
import EditParent from "./components/Superadmin/Parents/EditParent";
//import Physician from "./components/Superadmin/Physician/Physician";
import Physician from "./shared/components/Physician";
import ViewParent from "./components/Superadmin/Parents/ViewParent";
//import AddPhysician from "./components/Superadmin/Physician/AddPhysician";
import AddPhysician from "./shared/components/AddPhysician";
// import EditPhysicianHospital from "./components/HospitalAdmin/Physician/EditPhysician";
// import ViewPhysicianHospital from "./components/HospitalAdmin/Physician/ViewPhysician";
import EditPhysician from "./shared/components/EditPhysician";
import Hospital from "./components/Superadmin/Hospital/Hospital";
import ViewPhysician from "./shared/components/ViewPhysician";
import AddHospital from "./components/Superadmin/Hospital/AddHospital";
import EditHospital from "./components/Superadmin/Hospital/EditHospital";
import ViewHospital from "./components/Superadmin/Hospital/ViewHospital";
import AdminProfile from "./components/Superadmin/Profile/Profile";
import AdminEditProfile from "./components/Superadmin/Profile/EditProfile";
import ClinicalStaff from "./components/Superadmin/ClinicalStaff/ClinicalStaff";
import AddClinicalStaff from "./components/Superadmin/ClinicalStaff/AddClinicalStaff";
import ViewClinicalStaff from "./components/Superadmin/ClinicalStaff/ViewClinicalStaff";
import AddDevelopment from "./shared/components/AddDevelopment";
import AddMeasurement from "./shared/components/AddMeasurement";
import AddMedicalIssues from "./shared/components/AddMedicalIssues";
import AddVaccination from "./shared/components/AddVaccination";
import VerifyLogin from "./components/Home/VerifyLogin";
import HospitalAdminProfile from "./components/HospitalAdmin/Profile/Profile";
import HospitalAdminEditProfile from "./components/HospitalAdmin/Profile/EditProfile";
import UpcomingVaccination from "./shared/components/UpcomingVaccination";
import MissedVcacination from "./shared/components/MissedVaccination";

/** To decalre all routes **/
function MainRoutes() {
  /** This function is used to check User loggedIn or not **/
  useEffect(() => {
    (async () => {
      await ApiService.isLoggedIn();
    })();
  }, []);

  return (
    <Routes>
      <Route path="*" element={<LandingTemplate />} />
      {/* Landing Routes */}
      <Route path="/" element={<LandingTemplate />}>
        <Route path="/" element={<HeroBanner />} />
        <Route path="/about" element={<AboutNurture />} />
        <Route path="/parents" element={<LandingParents />} />
        <Route path="/clinics" element={<Clinics />} />
        <Route path="/request" element={<RequestDemo />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Route>
      {/*<Route path='/' element={<Landing />} />*/}
      <Route path="/register" element={<Register />} />
      <Route path="/create-password" element={<CreatePassword />} />
      <Route path="/login/physician" element={<PhysicianLogin />} />
      <Route path="/login/admin" element={<SuperAdminLogin />} />
      <Route path="/login/hospital/admin" element={<HospitalAdminLogin />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/login/verify" element={<VerifyLogin />} />
      {/* Physician Routes */}
      <Route path="/physician" element={<Template />}>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="profile" element={<ViewProfile />} />
        <Route path="edit-profile" element={<EditProfile />} />
        <Route path="appointments" element={<Appointments />} />
        <Route path="parent-list" element={<Parents />} />
        <Route path="vaccination" element={<Vaccination />} />
        <Route path="development" element={<Development />} />
        <Route path="upcoming-vaccine" element={<UpcomingVaccination />} />
        <Route path="missed-vaccine" element={<MissedVcacination />} />
		    <Route path="measurement" element={<Measurement />} />
        <Route path="medical-issues" element={<MedicalIssues />} />
        <Route path="messages" element={<Chat />} />
        <Route path="settings" element={<AccountSettings />} />
        <Route path="member-profile/:id" element={<MemberProfile />} />
        <Route path="notification" element={<Notification />} />
		    <Route path="add-development/:id" element={<AddDevelopment />} />
        <Route path="add-measurement/:id" element={<AddMeasurement />} />
        <Route path="add-medical-issues/:id" element={<AddMedicalIssues />} />
        <Route path="add-vaccination/:id" element={<AddVaccination />} />
      </Route>
      {/* Parent Routes */}
      <Route path="/parent" element={<Template />}>
        <Route path="dashboard" element={<ParentDashboard />} />
        <Route path="messages" element={<Chat />} />
        <Route path="settings" element={<ParentDashboard />} />
        <Route path="profile" element={<ParentDashboard />} />
        <Route path="notification" element={<Notification />} />
      </Route>
      {/* Superadmin Routes */}
      <Route path="/admin" element={<Template />}>
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="settings" element={<AccountSettings />} />
        <Route path="parents" element={<Parent />} />
        <Route path="add-parent" element={<AddParent />} />
        <Route path="parent/:id" element={<ViewParent />} />
        <Route path="edit-parent/:id" element={<EditParent />} />
        <Route path="physician" element={<Physician />} />
        <Route path="add-physician" element={<AddPhysician />} />
        <Route path="edit-physician/:id" element={<EditPhysician />} />
        <Route path="physician/:id" element={<ViewPhysician />} />
        <Route path="hospital" element={<Hospital />} />
        <Route path="add-hospital" element={<AddHospital />} />
        <Route path="edit-hospital/:id" element={<EditHospital />} />
        <Route path="hospital/:id" element={<ViewHospital />} />
        <Route path="profile" element={<AdminProfile />} />
        <Route path="edit-profile" element={<AdminEditProfile />} />
		    <Route path="clinical-staff" element={<ClinicalStaff />} />
        <Route path="add-clinical-staff" element={<AddClinicalStaff />} />
        <Route path="view-clinical-staff" element={<ViewClinicalStaff />} />
      </Route>
      {/* Hospital admin Routes */}
      <Route path="/hospital/admin" element={<Template />}>
        <Route path="dashboard" element={<HospitalAdminDashboard />} />
        {/* <Route path="parents" element={<HospitalParent />} /> */}
        <Route path="parents" element={<Parent />} />
        <Route path="children" element={<Dashboard />} />
        <Route path="add-parent" element={<HospitalAddParent />} />
        <Route path="edit-parent/:id" element={<HospitalEditParent />} />
        <Route path="view-parent/:id" element={<HospitalViewParent />} />
        <Route path="add-children" element={<HospitalAddChildren />} />
        <Route path="edit-children/:id" element={<HospitalEditChildren />} />
        <Route path="view-children/:id" element={<MemberProfile />} />
        {/*  <Route path="view-children/:id" element={<HospitalViewChildren />} /> */}
        <Route path="physician" element={<Physician />} />
        <Route path="add-physician" element={<AddPhysician />} />
        <Route path="edit-physician/:id" element={<EditPhysician />} />
        <Route path="view-physician/:id" element={<ViewPhysician />} />
        <Route path="appointments" element={<Appointments />} />
        <Route path="profile" element={<HospitalAdminProfile />} />
        <Route path="edit-profile" element={<HospitalAdminEditProfile />} />
        <Route path="settings" element={<AccountSettings />} />
        <Route path="add-development/:id" element={<AddDevelopment />} />
        <Route path="add-measurement/:id" element={<AddMeasurement />} />
        <Route path="add-medical-issues/:id" element={<AddMedicalIssues />} />
        <Route path="add-vaccination/:id" element={<AddVaccination />} />
        <Route path="upcoming-vaccine" element={<UpcomingVaccination />} />
        <Route path="missed-vaccine" element={<MissedVcacination />} />
        <Route path="notification" element={<Notification />} />
      </Route>
    </Routes>
  );
}

export default MainRoutes;
